import { GermplasmPairModel } from '../../../head-to-head-query/model/germplasm-pair.model';

export class TrialEnvironmentSearchRequest {
    constructor(public traits?: number[],
                public studyFilter?: number[],
                public locationFilter?: number[],
                public envConditions?: number[],
                public environmentIds?: number[],
                public germplasmPairs?: GermplasmPairModel[]
    ) {
    }
}